
import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        portfolioThemes: [
            {
                id: 1,
                img: require('@/assets/images/pt-1.jpg'),
                title: 'Made',
                subtitle: 'A bold, minimal portfolio theme',
                price: '$49',
                marker: 'Made by us!',
                cardLink: '/product-single'
            },
            {
                id: 2,
                img: require('@/assets/images/pt-2.jpg'),
                title: 'Personal',
                subtitle: 'A sleek, modern personal website theme',
                price: '$49',
                marker: 'Made by us!',
                cardLink: '/product-single'
            },
            {
                id: 3,
                img: require('@/assets/images/pt-3.jpg'),
                title: 'Duet',
                subtitle: 'A beautiful two-column portfolio theme',
                price: '$49',
                marker: 'Made by us!',
                cardLink: '/product-single'
            },
            {
                id: 4,
                img: require('@/assets/images/pt-4.jpg'),
                title: 'Creative',
                subtitle: 'One page Bootstrap theme',
                price: 'Free',
                marker: '',
                cardLink: '/product-single'
            },
            {
                id: 5,
                img: require('@/assets/images/pt-5.jpg'),
                title: 'Index',
                subtitle: 'A minimal, fixed sidebar portfolio theme',
                price: '$49',
                marker: 'Made by us!',
                cardLink: '/product-single'
            },
            {
                id: 6,
                img: require('@/assets/images/pt-6.jpg'),
                title: 'Forty',
                subtitle: 'Landing page and portfolio theme',
                price: 'Free',
                marker: '',
                cardLink: '/product-single'
            },
            {
                id: 7,
                img: require('@/assets/images/pt-7.jpg'),
                title: 'Board',
                subtitle: 'A stylish masonry grid Jekyll theme',
                price: '$49',
                marker: 'Made by us!',
                cardLink: '/product-single'
            },
            {
                id: 8,
                img: require('@/assets/images/pt-8.jpg'),
                title: 'Sinai',
                subtitle: 'Minimal magazine-style theme',
                price: '$59',
                marker: '',
                cardLink: '/product-single'
            },
            {
                id: 9,
                img: require('@/assets/images/pt-9.jpg'),
                title: 'Agency',
                subtitle: 'A landing page and portfolio theme',
                price: 'Free',
                marker: '',
                cardLink: '/product-single'
            }
        ],
        blogThemes: [
            {
                id: 1,
                img: require('@/assets/images/pt-10.jpg'),
                title: 'Journal',
                subtitle: 'A stunning personal website/blog theme',
                price: '$49',
                marker: 'Made by us!',
                cardLink: '/product-single'
            },
            {
                id: 2,
                img: require('@/assets/images/pt-11.jpg'),
                title: 'Aditu',
                subtitle: 'Stylish dark theme',
                price: '$29',
                marker: '',
                cardLink: '/product-single'
            },
            {
                id: 3,
                img: require('@/assets/images/pt-12.jpg'),
                title: 'Horace',
                subtitle: 'Slick + minimal single-author blog theme',
                price: '$29',
                marker: '',
                cardLink: '/product-single'
            },
            {
                id: 4,
                img: require('@/assets/images/pt-13.jpg'),
                title: 'Alembic',
                subtitle: 'A boilerplate/starter theme',
                price: 'free',
                marker: '',
                cardLink: '/product-single'
            },
            {
                id: 5,
                img: require('@/assets/images/pt-14.jpg'),
                title: 'Simples',
                subtitle: 'A super simple blogging theme for Jekyll',
                price: '$49',
                marker: 'Made by us!',
                cardLink: '/product-single'
            },
            {
                id: 6,
                img: require('@/assets/images/pt-15.jpg'),
                title: 'Royce',
                subtitle: 'Subtle + minimal single-author blog theme',
                price: '$29',
                marker: '',
                cardLink: '/product-single'
            },
            {
                id: 7,
                img: require('@/assets/images/pt-16.jpg'),
                title: 'Minimal Mistakes',
                subtitle: 'Flexible two-column Jekyll theme',
                price: 'free',
                marker: '',
                cardLink: '/product-single'
            },
            {
                id: 8,
                img: require('@/assets/images/pt-17.jpg'),
                title: 'Clifford',
                subtitle: 'Blog + magazine theme for Jekyll',
                price: '$35',
                marker: '',
                cardLink: '/product-single'
            },
            {
                id: 9,
                img: require('@/assets/images/pt-18.jpg'),
                title: 'Hally',
                subtitle: 'Minimal masonry Jekyll theme',
                price: '$29',
                marker: '',
                cardLink: '/product-single'
            },
            {
                id: 10,
                img: require('@/assets/images/pt-19.jpg'),
                title: 'Melotta',
                subtitle: 'Modern + minimal theme',
                price: '$29',
                marker: '',
                cardLink: '/product-single'
            },
            {
                id: 11,
                img: require('@/assets/images/pt-20.jpg'),
                title: 'Forma',
                subtitle: 'Bold masonry blog theme',
                price: '$29',
                marker: '',
                cardLink: '/product-single'
            },
            {
                id: 12,
                img: require('@/assets/images/pt-21.jpg'),
                title: 'Olania',
                subtitle: 'Minimal blog + magazine theme',
                price: '$35',
                marker: '',
                cardLink: '/product-single'
            }
        ],
        landingThemes: [
            {
                id: 1,
                img: require('@/assets/images/pt-22.jpg'),
                title: 'Stocky',
                subtitle: 'Marketplace Jekyll Theme',
                price: '$49',
                marker: '',
                cardLink: '/product-single'
            },
            {
                id: 2,
                img: require('@/assets/images/pt-23.jpg'),
                title: 'Softdash',
                subtitle: 'Creative SaaS business template',
                price: '$27',
                marker: '',
                cardLink: '/product-single'
            },
            {
                id: 3,
                img: require('@/assets/images/pt-24.jpg'),
                title: 'Serif',
                subtitle: 'Beautiful small business theme',
                price: 'free',
                marker: '',
                cardLink: '/product-single'
            },
            {
                id: 4,
                img: require('@/assets/images/pt-25.jpg'),
                title: 'Trade',
                subtitle: 'Corporate and business template',
                price: '$33',
                marker: '',
                cardLink: '/product-single'
            },
            {
                id: 5,
                img: require('@/assets/images/pt-26.jpg'),
                title: 'Hydra',
                subtitle: 'Product or SaaS marketing theme',
                price: 'free',
                marker: '',
                cardLink: '/product-single'
            },
            {
                id: 6,
                img: require('@/assets/images/pt-27.jpg'),
                title: 'Wrap',
                subtitle: 'A great single-page theme',
                price: '$24',
                marker: '',
                cardLink: '/product-single'
            }
        ],
        documentationThemes: [
            {
                id: 1,
                img: require('@/assets/images/pt-28.jpg'),
                title: 'Doks',
                subtitle: 'Project documentation Jekyll theme',
                price: '$29',
                marker: '',
                cardLink: '/product-single'
            },
            {
                id: 2,
                img: require('@/assets/images/pt-29.jpg'),
                title: 'Desk',
                subtitle: 'Knowledge base & FAQ Jekyll theme',
                price: '$29',
                marker: '',
                cardLink: '/product-single'
            },
            {
                id: 3,
                img: require('@/assets/images/pt-30.jpg'),
                title: 'Help Center',
                subtitle: 'Simple + responsive support theme',
                price: 'Free',
                marker: '',
                cardLink: '/product-single'
            },
            {
                id: 4,
                img: require('@/assets/images/pt-31.jpg'),
                title: 'Documentation',
                subtitle: 'Documentation + help systems theme',
                price: 'Free',
                marker: '',
                cardLink: '/product-single'
            },
            {
                id: 5,
                img: require('@/assets/images/pt-32.jpg'),
                title: 'Doxy',
                subtitle: 'Knowledgebase and documentation theme',
                price: '$29',
                marker: '',
                cardLink: '/product-single'
            },
            {
                id: 6,
                img: require('@/assets/images/pt-33.jpg'),
                title: 'Documenter',
                subtitle: 'Support, knowledgebase + documentation theme',
                price: '$29',
                marker: '',
                cardLink: '/product-single'
            }
        ],
        githubThemes: [
            {
                id: 1,
                img: require('@/assets/images/pt-34.jpg'),
                title: 'Personal',
                subtitle: 'A sleek, modern personal website theme',
                price: '$49',
                marker: 'Made by us!',
                cardLink: '/product-single'
            },
            {
                id: 2,
                img: require('@/assets/images/pt-35.jpg'),
                title: 'Minimal Mistake',
                subtitle: 'Flexible two-column Jekyll theme',
                price: 'Free',
                marker: '',
                cardLink: '/product-single'
            },
            {
                id: 3,
                img: require('@/assets/images/pt-36.jpg'),
                title: 'Journal',
                subtitle: 'A stunning personal website/blog theme',
                price: '$49',
                marker: 'Made by us!',
                cardLink: '/product-single'
            },
            {
                id: 4,
                img: require('@/assets/images/pt-37.jpg'),
                title: 'Gridster',
                subtitle: 'Material design Jekyll theme',
                price: 'free',
                marker: '',
                cardLink: '/product-single'
            },
            {
                id: 5,
                img: require('@/assets/images/pt-38.jpg'),
                title: 'Made',
                subtitle: 'A bold, minimal portfolio theme',
                price: '$49',
                marker: 'Made by us!',
                cardLink: '/product-single'
            },
            {
                id: 6,
                img: require('@/assets/images/pt-39.jpg'),
                title: 'Royce',
                subtitle: 'Subtle + minimal single-author blog theme',
                price: '$29',
                marker: '',
                cardLink: '/product-single'
            }
        ]
    }
})


